import { styled, ToggleButton } from '@mui/material';

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&.Mui-selected': {
    backgroundColor: 'white',
    borderColor: '#f49d3f',
    color: '#f49d3f',
    margin: '0px 3px',
    fontWeight: 700,
    border: '1px solid #f49d3f',
    '&:hover': {
      backgroundColor: 'rgba(244, 157, 63, .1)',
    },
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'white',
    color: 'black',
    borderColor: 'black',
    margin: '0px 3px',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'lightgray',
    },
  },
}));

export default StyledToggleButton;
// Can be removeed if not required anywhere else